import { APIGet, APIPost, APIDelete } from "api/protocols";
import { CancelToken } from "axios";
import { IProduct, IVariant } from "redux/reducers/models/product";
import { ITournament } from "redux/reducers/models/tournament";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/tournament";

export type TGetTournamentRegistrationFee = {
  id?: string | number;
  tournament_id?: string | number;
  variant_id?: string | number;
};

export type TPostTournamentRegistrationFee = {
  tournament_id: string | number;
  variant_id: string | number;
  players?: number;
  type?: string; // defaults to registration_fee
  description?: string;
  price: number;
};

export interface IRegistrationFee {
  description: string;
  id: number;
  tournament?: ITournament;
  tournament_id: number;
  players: number;
  product?: IProduct;
  product_id: number;
  product_title: string;
  type: string;
  variant?: IVariant;
  variant_id: number;
  variant_title: string;
}

export async function GetTournamentRegistrationFees(
  params: TGetTournamentRegistrationFee,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(baseUrl + "/registration-fee", params, useGlobalLoader, token);
}

export async function PostTournamentRegistrationFee(params: TPostTournamentRegistrationFee, useGlobalLoader: boolean) {
  return await APIPost(baseUrl + "/registration-fee", params, useGlobalLoader);
}

export async function DeleteTournamentRegistrationFee(
  params: { registration_fee_id: string | number },
  useGlobalLoader: boolean,
) {
  return await APIDelete(baseUrl + "/registration-fee", params, useGlobalLoader);
}
